export const SpaceSettingModel = Symbol.for('SpaceSettingModel');
